import React from 'react';
import { Tooltip } from 'antd';
import {
  MetricCardContainer,
  MetricIconWrapper,
  MetricContent,
  MetricValue,
  MetricLabel
} from '../../styles/checkoutStyles';

const MetricCard = ({ icon, value, label, tooltip }) => {
  const card = (
    <MetricCardContainer style={tooltip ? { cursor: 'pointer' } : undefined}>
      <MetricIconWrapper>{icon}</MetricIconWrapper>
      <MetricContent>
        <MetricLabel>{label}</MetricLabel>
        <MetricValue>{value}</MetricValue>
      </MetricContent>
    </MetricCardContainer>
  );

  if (!tooltip) return card;

  return <Tooltip title={tooltip}>{card}</Tooltip>;
};

export default MetricCard;
